"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clamp = void 0;
/**
 * Returns the value or the min or max if the value is outside those bounds (which are inclusive).
 */
function clamp(value, min, max) {
    if (max < min) {
        return NaN;
    }
    return Math.min(Math.max(value, min), max);
}
exports.clamp = clamp;
//# sourceMappingURL=Math.js.map